define('modules/editor/models/property_groups/social_google',['require','exports','module','./social'],function(require, exports, module){
	"use strict";
  var SocialPropertyGroup = require("./social");
  module.exports = SocialPropertyGroup.extend({
    name: "social:google"
  });
});

